import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { BookOpen, Code, Brain, Palette, Heart, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '../utils/createPageUrl.js'; // ודאי שהנתיב נכון

export default function CategoriesPage() {
    const { t } = useTranslation();

    // אובייקטים אלה נשארים כפי שהם, ודאי שהם מכילים את כל הקטגוריות
    const categoryIcons = { Code, FileText, Brain, Palette, Heart, BookOpen };
    const categoryColors = {
        computer_science: 'bg-[#b8c1ec] text-[#232946]',
        judaism_philosophy: 'bg-[#eebbc3] text-[#232946]',
        neuroscience: 'bg-[#d4d8f0] text-[#232946]',
        art: 'bg-[#fffffe] text-[#232946]',
        psychology: 'bg-[#8890b3] text-white',
        other: 'bg-[#232946] text-white'
    };
    const categoryIconMap = {
        computer_science: 'Code',
        judaism_philosophy: 'FileText',
        neuroscience: 'Brain',
        art: 'Palette',
        psychology: 'Heart',
        other: 'BookOpen'
    }

    // --- כאן התיקון ---
    // אנחנו מסננים החוצה את המפתח 'all' לפני שאנחנו יוצרים את המערך
    const categories = Object.keys(t('categories', { returnObjects: true }))
        .filter(key => key !== 'all')
        .map(key => ({
            id: key,
            name: t(`categories.${key}`),
            description: t(`pages.categories.descriptions.${key}`, key), // הוספתי ערך ברירת מחדל
            icon: categoryIcons[categoryIconMap[key]],
            color: categoryColors[key],
            textColor: (categoryColors[key] || '').includes('white') ? 'text-white' : 'text-[#232946]'
        }));

    return (
        <div className="container mx-auto px-4 py-12">
            <div className="max-w-4xl mx-auto">
                <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-4xl font-bold text-[#232946] mb-4">
                    {t('pages.categories.title')}
                </motion.h1>
                <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="text-lg text-[#8890b3] mb-12">
                    {t('pages.categories.subtitle')}
                </motion.p>

                <div className="grid md:grid-cols-2 gap-6">
                    {categories.map((category, index) => {
                        const Icon = category.icon;
                        return (
                            <motion.div key={category.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.1 }}>
                                <Link to={createPageUrl('category', { category: category.id })} className="block">
                                    <div className={`${category.color} rounded-2xl p-6 transition-transform duration-300 hover:scale-105`}>
                                        <div className="flex items-start gap-4">
                                            <div className={`p-3 rounded-xl bg-white/20 ${category.textColor}`}>
                                                {Icon && <Icon className="w-6 h-6" />}
                                            </div>
                                            <div>
                                                <h2 className={`text-xl font-bold mb-2 ${category.textColor}`}>
                                                    {category.name}
                                                </h2>
                                                <p className={`${category.textColor} opacity-80`}>
                                                    {category.description}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}